import React from 'react';
import PropTypes from 'prop-types';

// TODO, instead of adding new context, the withContext should be reused
// as it already automatically passes all the custom props down to items
const DropdownContext = React.createContext();
const DropdownItem = () => 'item';

/**
 * HOC for TabsList to enhance behavior with ScrollContainer
 */
export default function withDropdown([WrappedTabsList, WrappedTabsItem]) {
  function DropdownTabsList({ children, ...inheritedProps }) {
    return (
      <DropdownContext.Provider value={{ __isMinimized: true }}>
        <WrappedTabsList {...inheritedProps} />
      </DropdownContext.Provider>
    );
  }

  DropdownTabsList.propTypes = {
    children: PropTypes.node,
    // TODO: add more proptypes
  };

  /**
   * Override component name by prepending `Dropdown~`
   * to make it look nice, for example: `DropdownTabsList`
   */
  if (process.env.NODE_ENV !== 'production') {
    const WrappedComponentName = WrappedTabsList.displayName || WrappedTabsList.name || 'TabsList';
    DropdownTabsList.displayName = `Dropdown${WrappedComponentName}`;
  }

  function DropdownTabsItem(props) {
    return (
      <DropdownContext.Consumer>
        {({ __isMinimized }) =>
          __isMinimized ? <DropdownItem {...props} /> : <WrappedTabsItem {...props} />
        }
      </DropdownContext.Consumer>
    );
  }

  DropdownTabsItem.propTypes = {
    children: PropTypes.node,
    // TODO: add more proptypes
  };

  /**
   * Override component name by prepending `Dropdown~`
   * to make it look nice, for example: `DropdownTabsItem`
   */
  if (process.env.NODE_ENV !== 'production') {
    const WrappedComponentName = WrappedTabsList.displayName || WrappedTabsList.name || 'TabsItem';
    DropdownTabsItem.displayName = `Dropdown${WrappedComponentName}`;
  }
  return [DropdownTabsList, DropdownTabsItem];
}
